import { useState } from "react";
import { useLang } from "../../context/LanguageContext";

export default function Reviews() {
  const { t } = useLang();
  const [idx, setIdx] = useState(0);
  const list = t.reviews.list;
  const active = list[idx];

  return (
    <section id="reviews" data-testid="reviews-section" className="section-pad bg-[hsl(var(--cream))]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="overline mb-5">{t.reviews.eyebrow}</div>
            <h2 className="font-serif font-light text-3xl md:text-4xl leading-tight text-[hsl(var(--foreground))] whitespace-pre-line">
              {t.reviews.title}
            </h2>
          </div>

          <div className="lg:col-span-8">
            <blockquote data-testid="review-quote" className="font-serif italic text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-[hsl(var(--foreground))]">
              “{active.quote}”
            </blockquote>
            <div className="mt-10 flex items-center justify-between flex-wrap gap-6">
              <div>
                <div className="font-medium text-[hsl(var(--foreground))]">{active.author}</div>
                <div className="text-sm text-[hsl(var(--foreground))]/78">{active.origin}</div>
              </div>
              <div className="flex items-center gap-3">
                {list.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    data-testid={`review-dot-${i}`}
                    className={`h-px transition-all ${idx === i ? "w-12 bg-[hsl(var(--accent))]" : "w-6 bg-[hsl(var(--foreground))]/25"}`}
                    aria-label={`Review ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
